import { render, staticRenderFns } from "./CoffeeList.vue?vue&type=template&id=e3f9b95a&scoped=true"
import script from "./CoffeeList.vue?vue&type=script&lang=js"
export * from "./CoffeeList.vue?vue&type=script&lang=js"
import style0 from "./CoffeeList.vue?vue&type=style&index=0&id=e3f9b95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f9b95a",
  null
  
)

export default component.exports